__webpack_require__.p = "/PhysPropertiesBOT/";